import { render } from "./AboutScreenFeatures.vue?vue&type=template&id=1024f38c&scoped=true"
import script from "./AboutScreenFeatures.vue?vue&type=script&lang=js"
export * from "./AboutScreenFeatures.vue?vue&type=script&lang=js"

import "./AboutScreenFeatures.vue?vue&type=style&index=0&id=1024f38c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1024f38c"]])

export default __exports__